import apiServices from "../apiServices";
import { validateOrThrowApiResponse } from "../response-validator";

type CreateSequenceAPIPayload = {
    create_by?: string;
    exercise_name: string;
    description?: string;
    subject: string;
    group_id?: number | string;
    teacher_uuid?: string;
    sequence_default?: boolean;
    thumbnail?: File | Blob | null;
    thumbnailFileName?: string;
};

type AddGameToSequencePayloadItem = {
    sequenceId: number | string;
    gameId: number | string;
};

type HardDeleteGameInSequencePayload = {
    sequenceId: number | string;
    gameIds: Array<number | string>;
};

const sequenceAPI = {

    createSequence(payload: CreateSequenceAPIPayload) {
        const formData = new FormData();
        formData.append("create_by", payload.create_by || "");
        formData.append("exercise_name", payload.exercise_name);
        formData.append("description", payload.description || "");
        formData.append("subject", payload.subject);
        if (payload.group_id) {
            formData.append("group_id", payload.group_id.toString());
        }
        if (payload.teacher_uuid) {
            formData.append("teacher_uuid", payload.teacher_uuid);
        }
        if (payload.sequence_default !== undefined) {
            formData.append("sequence_default", payload.sequence_default.toString());
        }
        if (payload.thumbnail) {
            if (payload.thumbnailFileName) {
                formData.append("thumbnail", payload.thumbnail, payload.thumbnailFileName);
            } else {
                formData.append("thumbnail", payload.thumbnail);
            }
        }
        return apiServices
            .post(`/api/sequence`, formData, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error createSequence:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    addGameToSequence(payload: AddGameToSequencePayloadItem[]) {
        return apiServices
            .post(`/api/sequence/addGames`, payload, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error addGameToSequence:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    getGameInSequenceByUuid(uuid: string) {
        return apiServices
            .get(`/api/sequence/uuid/${uuid}`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error getGameInSequenceByUuid:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    hardDeleteGameInSequence(payload: HardDeleteGameInSequencePayload) {
        return apiServices
            .delete(`/api/sequence/${payload.sequenceId}/games`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                data: {
                    gameIds: payload.gameIds,
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error hardDeleteGameInSequence:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    softDeleteSequenceById(id: string) {
        return apiServices
            .patch(`/api/sequence/${id}/soft-delete`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error softDeleteSequenceById:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    updateExcerciseName(id: number | string, exercise_name: string) {
        return apiServices
            .patch(`/api/sequence/${id}/exerciseName`, { exercise_name }, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error updateExcerciseName:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

}

export default sequenceAPI;